import { Message } from 'semantic-ui-react'

import { useAuth } from 'lib/context/AuthContext'
import EmailVerification from './EmailVerification'

const Messages = () => {
  const [user] = useAuth()

  return (
    <>
      {!user.auth.emailVerified && <EmailVerification user={user.auth} />}
      {!user.auth.phoneNumber && user.data.delivery === 'sms' && (
        <Message
          warning
          icon="warning circle"
          header="Add your phone number"
          content={
            <p>
              You chose to receive alerts via SMS / Text but we don't have your
              phone number. Add your phone number to be able to receive
              messages.
            </p>
          }
        />
      )}
    </>
  )
}

export default Messages
